export const ACCESS_TYPE = {
    private: 'private',
    shared: 'shared',
};
